export default __webpack_public_path__ + "navigation-examples-styled-ui-elements-thumbnail-v1-480-3f94a0a0974e0c531bfd874e3feafc7d.png";